import { render, staticRenderFns } from "./DynamicFeaturesPage.vue?vue&type=template&id=2e6ca4f4&"
import script from "./DynamicFeaturesPage.vue?vue&type=script&lang=js&"
export * from "./DynamicFeaturesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports